(function () {
    angular
      .module('kareo.ui.shared.directives.K-enrl-selected-payer-enrollments', ['kareo.ui.shared.modules.featureSet'])
      .directive('kEnrlSelectedPayerEnrollments', kEnrlSelectedPayerEnrollments);
  
    function kEnrlSelectedPayerEnrollments() {
      const directive = {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        scope: {
          payer: '='
        },
        template: require('./k-enrl-selected-payer-enrollments.pug')()
      };
  
      return directive;
    }
  
    //--------------------------------------
    controller.$inject = ['featureSet'];
  
    function controller(featureSet) {
      const vm = this;
  
      vm.isValid = isValid;
  
      featureSet.load().then((features) => {
        if (features['dark-feature.enrollments-upgrade-phase2']
          || features['dark-feature.enrollments-upgrade-phase3']) {
          vm.eraLive = vm.payer.eraStatusDisplay.status === 'LIVE';
        }
      });
  
      function isValid() {
        // Payer [serviceType]enrollmentRequired is named weird (DB side)
        // if enrollmentRequired == true (Manual enrollment work is needed)
        // if enrollmentRequired == false (Automatic enrollment)
  
        if (vm.payer.supportsEclaims && vm.payer.claimsEnrollmentRequired === false) {
          return false;
        }
  
        if (vm.payer.supportsPatientEligibilityRequests && vm.payer.eligibilityEnrollmentRequired === false) {
          return false;
        }
  
        if (vm.payer.supportsEra && vm.payer.eraEnrollmentRequired === false) {
          return false;
        }
  
        if (vm.payer.salesForceEnrollClaims === true ||
            vm.payer.salesForceEnrollEligibility === true ||
            vm.payer.salesForceEnrollEra === true) {
          return false;
        }
  
        if (vm.payer.salesForceEnrollClaimsNew === true ||
            vm.payer.salesForceEnrollEligibilityNew === true ||
            vm.payer.salesForceEnrollEraNew === true) {
          return false;
        }
  
        return true;
      }
    }
  })();
  